var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5027",
    "data-name": "Group 5027",
    transform: "translate(-864 -600)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6000",
    "data-name": "Path 6000",
    d: "M883.5,620h-15a.5.5,0,0,1-.5-.5v-15a.5.5,0,0,1,.5-.5h15a.5.5,0,0,1,.5.5v15A.5.5,0,0,1,883.5,620ZM869,619h14V605H869Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5024",
    "data-name": "Group 5024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6001",
    "data-name": "Path 6001",
    d: "M870.5,603a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,870.5,603Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6002",
    "data-name": "Path 6002",
    d: "M873.5,603a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,873.5,603Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6003",
    "data-name": "Path 6003",
    d: "M876.5,603a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,876.5,603Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6004",
    "data-name": "Path 6004",
    d: "M879.5,603a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,879.5,603Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6005",
    "data-name": "Path 6005",
    d: "M882.5,603a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,882.5,603Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6006",
    "data-name": "Path 6006",
    d: "M870.5,624a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,870.5,624Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6007",
    "data-name": "Path 6007",
    d: "M873.5,624a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,873.5,624Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6008",
    "data-name": "Path 6008",
    d: "M876.5,624a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,876.5,624Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6009",
    "data-name": "Path 6009",
    d: "M879.5,624a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,879.5,624Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6010",
    "data-name": "Path 6010",
    d: "M882.5,624a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,882.5,624Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5025",
    "data-name": "Group 5025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6011",
    "data-name": "Path 6011",
    d: "M866.5,619h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6012",
    "data-name": "Path 6012",
    d: "M866.5,616h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6013",
    "data-name": "Path 6013",
    d: "M866.5,613h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6014",
    "data-name": "Path 6014",
    d: "M866.5,610h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6015",
    "data-name": "Path 6015",
    d: "M866.5,607h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5026",
    "data-name": "Group 5026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6016",
    "data-name": "Path 6016",
    d: "M887.5,619h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6017",
    "data-name": "Path 6017",
    d: "M887.5,616h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6018",
    "data-name": "Path 6018",
    d: "M887.5,613h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6019",
    "data-name": "Path 6019",
    d: "M887.5,610h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6020",
    "data-name": "Path 6020",
    d: "M887.5,607h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6021",
    "data-name": "Path 6021",
    d: "M880.5,617h-9a.5.5,0,0,1-.5-.5v-9a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5v9A.5.5,0,0,1,880.5,617Zm-8.5-1h8v-8h-8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot);
export default __webpack_public_path__ + "static/media/iot.ea5ba5c08957ab933df6131ff09d9414.svg";
export { ForwardRef as ReactComponent };